/*
 * File: /src/router/routes/sms.js
 * Created Date: Sunday May 26th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 26th May 2019 11:58:32 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const SmsServicesList = () =>
  import(
    /* webpackChunkName: "SmsServices" */ 'src/components/Dashboard/Views/Tel/TelList.vue'
  );
const SmsServiceEdit = () =>
  import(
    /* webpackChunkName: "SmsServices" */ 'src/components/Dashboard/Views/Tel/TelEdit.vue'
  );
const SmsServiceConfigure = () =>
  import(
    /* webpackChunkName: "SmsServices" */ 'src/components/Dashboard/Views/Tel/TelConfigure.vue'
  );

// sms-services

// Menus

const MenuList = () =>
  import(
    /* webpackChunkName: "menuServices" */ 'src/components/Dashboard/Views/Tel/MenuList.vue'
  );
const MenuEdit = () =>
  import(
    /* webpackChunkName: "menuServices" */ 'src/components/Dashboard/Views/Tel/MenuEdit.vue'
  );


// Queues

const QueueList = () =>
  import(
    /* webpackChunkName: "queueServices" */ 'src/components/Dashboard/Views/Tel/QueueList.vue'
  );
const QueueEdit = () =>
  import(
    /* webpackChunkName: "queueServices" */ 'src/components/Dashboard/Views/Tel/QueueEdit.vue'
  );

// CallPlan

const CallPlanList = () =>
  import(
    /* webpackChunkName: "callPlanServices" */ 'src/components/Dashboard/Views/Tel/CallPlanList.vue'
  );
const CallPlanEdit = () =>
  import(
    /* webpackChunkName: "callPLanServices" */ 'src/components/Dashboard/Views/Tel/CallPlanEdit.vue'
  );

// Blocked Numbers

const BlockedNumberList = () =>
  import(
    /* webpackChunkName: "blockedNumberServices" */ 'src/components/Dashboard/Views/Tel/BlockedNumberList.vue'
  );

// Mailboxes

const MailboxList = () =>
  import(
    /* webpackChunkName: "voiceMailboxServices" */ 'src/components/Dashboard/Views/Tel/MailboxList.vue'
  );
const MailboxEdit = () =>
  import(
    /* webpackChunkName: "voiceMailboxServices" */ 'src/components/Dashboard/Views/Tel/MailboxEdit.vue'
  );

// Direct Dials

const DirectDialList = () =>
  import(
    /* webpackChunkName: "directDialServices" */ 'src/components/Dashboard/Views/Tel/DirectDialList.vue'
  );
const DirectDialEdit = () =>
  import(
    /* webpackChunkName: "directDialServices" */ 'src/components/Dashboard/Views/Tel/DirectDialEdit.vue'
  );


export const telRoutes = [
  {
    path: 'tel-services/list',
    name: 'Phone Numbers and Campaign Settings',
    component: SmsServicesList
  },
  {
    path: 'tel-services/add/',
    name: 'Add Voice & SMS Service',
    component: SmsServiceEdit
  },
  {
    path: 'tel-services/edit/:id',
    name: 'Editing Voice & SMS Service',
    component: SmsServiceEdit,
    props: route => ({ id: parseInt(route.params.id)}),
  },
  {
    path: 'tel-services/config/:id',
    name: 'Config Voice & SMS Service',
    component: SmsServiceConfigure
  },
  {
    path: 'tel-services/menus/list',
    name: 'Menus',
    component: MenuList
  },
  {
    path: 'tel-services/menus/edit/:id',
    name: 'Edit Menu',
    component: MenuEdit
  },
  {
    path: 'tel-services/menus/add/',
    name: 'Add Menu',
    component: MenuEdit
  },
  {
    path: 'tel-services/queues/list',
    name: 'Queues',
    component: QueueList
  },
  {
    path: 'tel-services/queues/edit/:id',
    name: 'Edit Queues',
    component: QueueEdit
  },
  {
    path: 'tel-services/queues/add/',
    name: 'Add Queue',
    component: QueueEdit
  },
  {
    path: 'tel-services/call-plans/list',
    name: 'Call Plans',
    component: CallPlanList
  },
  {
    path: 'tel-services/call-plans/edit/:id',
    name: 'Edit Call Plan',
    component: CallPlanEdit
  },
  {
    path: 'tel-services/call-plans/add/',
    name: 'Add Call Plan',
    component: CallPlanEdit
  },
  {
    path: 'tel-services/blocked-numbers/list/',
    name: 'Blocked Numbers',
    component: BlockedNumberList
  },
  {
    path: 'tel-services/mailboxes/list',
    name: 'Mailboxes',
    component: MailboxList
  },
  {
    path: 'tel-services/mailboxes/edit/:id',
    name: 'Edit Mailbox',
    component: MailboxEdit
  },
  {
    path: 'tel-services/mailboxes/add/',
    name: 'Add Mailbox',
    component: MailboxEdit
  },
  {
    path: 'tel-services/direct-dials/list',
    name: 'Direct Dials',
    component: DirectDialList
  },
  {
    path: 'tel-services/direct-dials/edit/:id',
    name: 'Edit Direct Dials',
    component: DirectDialEdit
  },
  {
    path: 'tel-services/direct-dials/add/',
    name: 'Add Direct Dial',
    component: DirectDialEdit
  },
];
